
export const COACHING_LINKS = {
  calendly: "https://calendly.com/pkr-recruit-and-hire/consultation-pkrhires",
  book: "https://www.amazon.com/Next-Level-Recruiting-Acquisition-Lifecycle/dp/1649530501",
  kellyLinkedIn: "https://www.linkedin.com/in/pkrhires",
};

export const COACHING_IMAGES = {
  hero: "/images/women-virtual-hero.jpg",
  about: "/images/woman-video-call.jpg",
  book: "/images/book.png",
  unsure: "/images/woman-leader.jpg",
};

export const PRESS = [
  { name: "Fast Company", logo: "/images/cdn/e274f38aed.png", scale: 0.85 },
  { name: "HR.com", logo: "/images/cdn/a9efe3789e.png", scale: 0.85 },
  { name: "HR Daily Advisor", logo: "/images/cdn/f3c08469fa.png", scale: 0.85 },
  { name: "New York Weekly", logo: "/images/cdn/39cdd36b1b.png", scale: 1.35 },
  { name: "Tech Bullion", logo: "/images/cdn/f51d9c5f42.png", scale: 1.3 },
  { name: "CEO Weekly", logo: "/images/cdn/98e8ccd211.png", scale: 0.7 },
  { name: "The Wall Street Times", logo: "/images/cdn/417140b182.png", scale: 1.45 },
  { name: "Success", logo: "/images/cdn/b75e27b245.jpg", scale: 1.6 },
];

export const PROGRAMS = [
  {
    id: "leadership",
    number: "01",
    title: "1:1 Leadership Coaching",
    audience: "For women in leadership who are ready to evolve, scale, and take control of what's next.",
    summary: "A subscription-based personal and professional growth experience. This is not generic career coaching. It's structured, real-world coaching from a woman who has done the work and understands the juggle.",
    image: "/images/women-virtual-hero.jpg",
    includes: ["Finding and owning your voice at the table", "Balancing family, career, and everything in between", "Making time for yourself, without the guilt", "Executive presence, decision-making, and team leadership"],
  },
  {
    id: "mypact",
    number: "02",
    title: "myPACT Community",
    audience: "For women in leadership who want development without doing it alone.",
    summary: "A support system and growth space built on four values:",
    values: ["Proactive", "Accountable", "Collaborative", "Transparent"],
    summaryAfter: "It isn't about hustle. It's about alignment with values that actually drive results.",
    image: "/images/women-virtual-group.jpg",
    includes: ["Bi-weekly office hours", "Live sessions, real talk, and resources that matter", "Online community connection 24/7", "Private events with peers and leaders in your space"],
  },
  {
    id: "nlr",
    number: "03",
    title: "Next Level Recruiting Training",
    audience: "For corporate Talent Acquisition Partners and HR Generalists responsible for recruiting.",
    summary: "A 12-week program focused on recruiting with intention, structure, and integrity. Not beginner content, no fluff.",
    image: "/images/women-virtual-training.jpg",
    includes: ["12 weeks, 1 hour per week", "Live cohort or 1:1 training", "Based on Kelly's Next Level Recruiting book + workbook", "Built for those who want to build futures, not just fill positions"],
  },
];

export const CREDENTIALS = [
  "Founder of PKR Recruiting",
  "20+ years in Talent Management and Leadership",
  "Scaled from solo operator to a 7-figure business",
  "Trusted coach and advisor to founders, HR & TA professionals, C-suite and emerging leaders",
  "AI educator for modern leaders and teams",
];

export const COACHING_STORIES = [
  {
    id: "c1",
    quote: "Working with Kelly Robinson has been an absolute game changer for me as an executive leader. From the very beginning, Kelly created an environment of trust, challenge and clarity.",
    name: "Kirsti Coghlan",
    title: "Vice President, Human Resources",
    photo: "/images/cdn/3ae0a5dcef.png",
  },
  {
    id: "c2",
    quote: "It's pretty rare to come across a leader like Kelly Robinson. I recently took part in the Next Level Recruiting class which was incredibly engaging, and now I'm part of the myPACT community.",
    name: "Jennifer Kolbe",
    title: "Sr. Talent Acquisition Partner",
    photo: "/images/cdn/a803532ba5.png",
  },
  {
    id: "c3",
    quote: "The structured framework made even complex challenges manageable, and I saw immediate results. The NLR program has set me up for long-term success!",
    name: "Jessica Ryan",
    title: "HR Generalist",
    photo: "/images/cdn/06e21d29bd.png",
  },
  {
    id: "c4",
    quote: "I completed Kelly's NLR training and I cannot recommend it enough!",
    name: "Sarah Velohoski",
    title: "People Operations Specialist",
    photo: "/images/cdn/91817a96bf.png",
  },
  {
    id: "c5",
    quote: "Do yourself and your business a favor and set up an appointment with Kelly. You will not be disappointed.",
    name: "Charlie Wolter",
    title: "Founder & CEO",
    photo: "/images/cdn/f3d3b3e795.png",
  },
  {
    id: "c6",
    quote: "Kelly's AI coaching is one of the best customized classes out there I used for my job search.",
    name: "Alishah Hussain",
    title: "Project Manager",
    photo: "/images/cdn/ea4c739745.png",
  },
  {
    id: "c7",
    quote: "I hired Kelly for an AI job search strategy session, and it was one of the best decisions I could have made.",
    name: "Casey Frank",
    title: "Customer Success Manager",
    photo: "/images/cdn/173b863c56.png",
  },
];
